import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Platform } from 'ionic-angular';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { VasAppFacade } from '../../services/vas-app-facade.service';
import * as actions from './file.actions';

@Injectable()
export class FileShareEffects {

    get isDesktop(): boolean {
        return this.platform.is('core');
    }

    @Effect()
    share$ = this.actions$.ofType(actions.FILE_SHARE)
        .switchMap(action => {
            return this.appFacade.objects.file.cordova
                .fileExists(action.payload.file)
                .map(exists => {
                    return exists ?
                        new actions.FileShareLocalAction(action.payload) :
                        new actions.FileShareRemoteAction(action.payload);
                });
        });

    shareRemote$ = this.actions$.ofType(actions.FILE_SHARE_REMOTE)
        .switchMap(action => {
            return fromPromise(
                this.appFacade.loading.showLoading('Downloading file')
            )
                .concatMap(() =>
                    this.appFacade.objects.file.cordova.streamRemoteFileToDisk(
                        action.payload.file
                    )
                )
                .do(() => this.appFacade.loading.hideLoading())
                .map(fileEntry => new actions.FileShareLocalAction({
                    path: fileEntry.toURL()
                }))
                .catch(error => {
                    return fromPromise(this.appFacade.loading.hideLoading())
                        .concatMap(() =>
                            this.appFacade.toast.toastDanger(error)
                        );
                });
        });

    shareLocal$ = this.actions$.ofType(actions.FILE_SHARE_LOCAL)
        .switchMap(action => {
            return fromPromise(
                this.appFacade.objects.file.cordova.shareFile(
                    action.payload.url
                )
            )
                .catch(error => this.appFacade.toast.toastDanger(error));
        });

    constructor(
        protected actions$: Actions,
        protected platform: Platform,
        protected appFacade: VasAppFacade
    ) {

    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/file/file-share.effects.ts